import React from "react";
import TextLabel from "../../Controls/TextLabel.mjs";

const G = window.glob;

const AskForPasswordField = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { gm: G.getStatus('Player')?.admin?.gameMaster };
		this.ask = this.ask.bind(this);
	}
	ask() {
		this.setState({ pwd: '…' }, async () => {
			if ( this.state.to ) try { clearTimeout(this.state.to); } catch ( e ) { }
			const pwd = (await G.api({entity:'admin',operation:'get-user-password'},{playerID:this.props.player.id}))?.password;
			const to = pwd ? setTimeout( ()=>{ this.setState({pwd: null, to: null} )}, 5000) : null;
			this.setState({ pwd: pwd, to: to });
		});
	}
	render() {
		if ( ! this.state.gm) return <div style={{textAlign:'center'}}><i><TextLabel value={"Password"} /></i></div>;
		return (
			<div
				style={{cursor:'pointer',fontWeight:(this.state.pwd ? 'bold' : 'normal'),textAlign:'center'}}
				onClick={()=>{
					if ( this.state.pwd ){
						this.setState({pwd:''})
					} else {
						this.ask();
					}
				}}
			>
				{ this.state.pwd || <i><TextLabel value={"Password"} /></i> }
			</div>
		);
	}
}

const renderOtp = otp => {
	const [n,d] = otp.split('@');
	return [<b key={"name"}>{n}</b>,<small key={"domain"}>@{d}</small>];
}

const CastItem = class extends React.Component {
	render() {
		const p = this.props.player;
		//console.log(this.props.player);
		return(
			<tr className={"CastItem"}>
				<td>
					{ p.name }
				</td>
				<td>
					{ p.otp ? renderOtp(p.otp) : (p.admin?.gameMaster ? "— —" : <AskForPasswordField player={p} /> ) }
				</td>
				<td>
					{
						(p.role || [])
							.filter( a => !! a?.name )
							.sort( (a,b)=> ( a.name.toLowerCase().localeCompare( b.name.toLowerCase() ) ) )
							.map( r => `«${ r.name.replace(/ /g," ") }»` )
							.join(', ')
					}
				</td>
			</tr>
		);
	}
}
export default CastItem;